const URLS_MAP: TStringObject = {
  android: '//play.google.com/store/apps/details?id=ru.cian.main',
  ios: '//itunes.apple.com/app/id911804296',
  other: 'https://www.cian.ru/mobile/',
};

export const getDesktopUrl = (deviceOperatingSystem: string) => {
  return URLS_MAP[deviceOperatingSystem] || URLS_MAP['other'];
};
